import { IGetBodyVehicleDamageAmount } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleDamageAmount/getBodyVehicleDamageAmount.type';
import { getBodyVehicleDamageAmountQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleDamageAmount/getBodyVehicleDamageAmountQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyVehicleDamageAmountQueryOptions = (
  params: IGetBodyVehicleDamageAmount,
) =>
  queryOptions({
    queryKey: ['get_body_vehicle_damage_amount', params],
    queryFn: () => getBodyVehicleDamageAmountQueryFunction(params),
  });
